import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppRouter from './AppRouter';
import MapView from './MapView';
import reportWebVitals from './reportWebVitals';


window.renderEICMap = (containerId) => {
  ReactDOM.render(
    <React.StrictMode>
      <MapView />
    </React.StrictMode>,
    document.getElementById(containerId)
  );
  return function unmountEICMap () {
    ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
  };
};


if (document.getElementById('root')) {
  ReactDOM.render(
    <React.StrictMode>
      <AppRouter />
    </React.StrictMode>,
    document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
